import { Dialog } from "@dash/dialog";
import { Button } from "@dash/form";
import { useTheme } from "@emotion/react";
import React from "react";

export const ConfirmExecutionDialog = (props: {
  directionLabel: string;
  diffCount: number;
  isExecuting?: boolean;
  onClose: () => void;
  onConfirm: () => void;
}) => {
  const theme = useTheme();

  return (
    <Dialog
      header="Czy na pewno?"
      placement="center"
      onClose={props.isExecuting ? undefined : props.onClose}
      contentCss={{ width: "min(100%, 28rem)" }}
      footer={
        <div css={{ display: "flex", gap: "0.5rem", marginLeft: "auto" }}>
          <Button variant="outline" onClick={props.onClose} isDisabled={props.isExecuting}>
            Anuluj
          </Button>
          <Button onClick={props.onConfirm} isLoading={props.isExecuting}>
            {props.directionLabel}
          </Button>
        </div>
      }
    >
      <p css={{ margin: 0, color: theme.colors.primary }}>
        Operacja obejmie {props.diffCount} {formatDiffCount(props.diffCount)}.
      </p>
    </Dialog>
  );
};

const formatDiffCount = (count: number) => {
  if (count === 1) return "zaznaczoną zmianę";
  if (count % 10 >= 2 && count % 10 <= 4 && !(count % 100 >= 12 && count % 100 <= 14)) return "zaznaczone zmiany";
  return "zaznaczonych zmian";
};
